import { useCallback } from "react";
import { Switch } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { isAgentOnlineSelector } from "appredux/selectors";
import { setOnlineStatus } from "appredux/chatSlice";
import { usePostOnline } from "queries/conversation";

const OnlineStatus = () => {
  const dispatch = useDispatch();
  const isOnline = useSelector(isAgentOnlineSelector);
  const mutation = usePostOnline();

  const toggleOnline = useCallback(() => {
    const payload = isOnline === 1 ? 0 : 1;
    dispatch(setOnlineStatus(payload));
    mutation.mutate(payload, {
      onError: (err, variables) => {
        console.log(err);
        dispatch(setOnlineStatus(variables === 1 ? 0 : 1));
      },
    });
  }, [dispatch, isOnline, mutation]);

  return (
    <Switch
      checkedChildren="Online"
      unCheckedChildren="Offline"
      key={`switch-${isOnline}`}
      checked={isOnline === 1}
      onClick={toggleOnline}
      style={{ backgroundColor: isOnline === 1 ? "#61C92D" : "#bfbfbf" }}
      className="w-fit shrink-0 [&_.ant-switch-inner]:whitespace-nowrap"
    />
  );
};

export default OnlineStatus;
